import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ADMIN_ROLE } from "../helpers/constants";
import useAuth from "../hooks/useAuth";

const AdminRoute = () => {
  const { user } = useAuth();

  
  if (user && user?.role !== ADMIN_ROLE) {
    return <Navigate to="/" />;
  }
  return <Outlet />;
};

export default AdminRoute;
